import { all, fork, put, takeEvery, call, select } from "redux-saga/effects";
import { apiCall } from "App/Data/sagas";
import {
  actions,
  getters
} from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver/model";

import { eventDetails } from "redux/modules/portal/selectors";

import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";
import { userId as getUserId } from "redux/modules/user/selectors";

import { registerError } from "redux/modules/errors/actions";

const moduleId = STANDARD_MODULE_IDS.documentRequests.id;

const onInitMessages = function*() {
  yield put(actions.setLoadingMessages(true));

  try {
    const userId = yield select(getUserId);
    const eventDetailss = yield select(eventDetails);
    const { id: eventId } = eventDetailss || {};
    const { id: recordId } = yield select(getters.record);

    const { messages = [] } = yield call(apiCall, {
      method: "get",
      url: `/modules/${moduleId}/record/${recordId}/messages`,
      qs: {
        userId,
        eventId
      }
    });

    yield put(actions.setMessages(messages));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while loading messages"
        }
      ])
    );
  } finally {
    yield put(actions.setLoadingMessages(false));
  }
};

const onSendMessage = function*({ payload: { message } }) {
  try {
    yield put(actions.setLoadingMessages(true));
    const userId = yield select(getUserId);
    const eventDetailss = yield select(eventDetails);
    const { id: eventId } = eventDetailss || {};
    const { id: recordId } = yield select(getters.record);

    const { messages = [] } = yield call(apiCall, {
      method: "post",
      url: `/modules/${moduleId}/record/${recordId}/messages`,
      qs: {
        userId,
        eventId
      },
      data: {
        message: {
          content: message
        }
      }
    });

    yield put(actions.setMessages(messages));
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while loading messages"
        }
      ])
    );
  } finally {
    yield put(actions.initMessages());
  }
};

const watchInitMessages = function*() {
  yield takeEvery(actions.initMessages.type, onInitMessages);
};

const watchSendMessage = function*() {
  yield takeEvery(actions.sendMessage.type, onSendMessage);
};

const rootSaga = function*() {
  yield all([fork(watchInitMessages), fork(watchSendMessage)]);
};

export default rootSaga;
